"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withFetchLoader", {
  enumerable: true,
  get: function get() {
    return _FetchLoader["default"];
  }
});
var _FetchLoader = _interopRequireDefault(require("./FetchLoader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }